import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Button, TextField } from '@material-ui/core';

import {
  getOtp,
  verifyOtpAction,
  resetOtpAction,
  verifyMobileOtp,
} from '../../Actions/appAction';
import { isMobile } from '../../Functions/commonValidation';
import LanguageContext from '../common/languageContext';

class MobileLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileNumber: '',
      mobileOtp: '',
      mobileError: false,
    };
  }

  _getOtp = (type, ev) => {
    if (ev.key !== 'Tab') {
      const { getLogin } = this.props;
      const { mobileNumber } = this.state;
      const mobileErrorCheck = !isMobile(mobileNumber);
      this.setState({
        mobileError: mobileErrorCheck,
        mobileOtp: '',
      });
      if (!mobileErrorCheck) getLogin(mobileNumber, 'SIGNUP', type);
    }
  };

  _handleState = (type, event) => {
    const { /* verifyOtp, */ verifyOtpMobileAction, mobileNumber } = this.props;
    // const { mobileNumber } = this.state;
    if (type === 'mobileNumber') {
      if (event.target.value.length <= 10) {
        this.setState({
          mobileNumber: event.target.value,
          mobileError: false,
        });
      }
    }
    if (type === 'mobileOtp') {
      if (event.target.value.length <= 6) {
        this.setState({
          mobileOtp: event.target.value,
        });
      }
      if (event.target.value.length === 6) {
        verifyOtpMobileAction(event.target.value, mobileNumber, 'SIGNUP');
      }
    }
  };

  _backToMobile = () => {
    const { resetOtp, handleBackBtn } = this.props;
    resetOtp();
    handleBackBtn();
  };

  handleResendOtp = (otpType, ev) => {
    const { resendOtp } = this.props;
    this.setState({
      mobileOtp: '',
    });
    resendOtp(otpType, ev);
  };

  _renderBeforeOtp = () => {
    const { language } = this.context;
    const { mobileNumber, mobileError } = this.state;
    const { otpError } = this.props;
    return (
      <React.Fragment>
        <h1 className="top">You are one step away to</h1>
        <h2 className="bottom">Create a new account</h2>
        {/*    <Typography variant="h5">
          {(language.hindi && language.hindi['You are one step away to'])
            || 'You are one step away to'}
          <strong>
            {' '}
            {(language.hindi && language.hindi['Create a new account'])
              || 'Create New Account'}
          </strong>
        </Typography> */}
        <TextField
          id="standard-uncontrolled"
          label={
            (language.hindi && language.hindi['Mobile No.']) || 'Enter OTP'
          }
          className="textField inputHead"
          margin="normal"
          value={mobileNumber}
          onChange={event => this._handleState('mobileNumber', event)}
          error={!!mobileError}
          helperText={mobileError ? 'Please enter valid mobile number' : ''}
        />
        <p className="errorMsg">{otpError}</p>
        <ul>
          <li className="greyBtnHeader">{this.closeButton()}</li>
          <li className="darkgreenBtnHeader">
            <Button
              variant="contained"
              color="primary"
              className="button sub-btn"
              onClick={ev => this._getOtp('SMS', ev)}
            >
              {(language.hindi && language.hindi.Submit) || 'Submit'}
            </Button>
          </li>
        </ul>
      </React.Fragment>
    );
  };

  _renderAfterOtp = () => {
    const { language } = this.context;
    const { mobileOtp } = this.state;
    const { otpError } = this.props;
    return (
      <React.Fragment>
        <h1 className="top">You are one step away to</h1>
        <h2 className="bottom">Create a new account</h2>
        {/* <h5>
          {' '}
          {(language.hindi && language.hindi['OTP has been Sent to'])
            || 'OTP has been Sent to'}
          {` ${mobile}`}
        </h5> */}
        <TextField
          id="standard-uncontrolled"
          label={(language.hindi && language.hindi['Enter OTP']) || 'Enter OTP'}
          className="textField inputHead"
          margin="normal"
          value={mobileOtp}
          onChange={event => this._handleState('mobileOtp', event)}
        />
        <p className="errorMsg">{otpError}</p>
        {/* <div className="rightAlign">
          <span
            className="otpOnCallLink"
            onClick={ev => this._getOtp('CALL', ev)}
            onKeyDown={ev => this._getOtp('CALL', ev)}
            tabIndex="0"
            role="button"
          >
            {(language.hindi && language.hindi['get otp on call'])
              || 'get otp on call'}
          </span>
        </div> */}
        <ul>
          <li className="greyBtnHeader">
            <Button
              variant="contained"
              className="button back-btn"
              onClick={this._backToMobile}
            >
              {(language.hindi && language.hindi.Close) || 'Back'}
            </Button>
          </li>
          <li className="darkgreenBtnHeader">
            <Button
              variant="contained"
              color="primary"
              className="button darkgreenBtn"
              onClick={ev => this.handleResendOtp('SMS', ev)}
            >
              {(language.hindi && language.hindi['Resend OTP']) || 'Resend OTP'}
            </Button>
          </li>
        </ul>
      </React.Fragment>
    );
  };

  closeButton = () => {
    const { language } = this.context;
    const { handleOpenMobileLogin } = this.props;
    return (
      <Button
        variant="contained"
        className="button back-btn"
        onClick={() => handleOpenMobileLogin(false)}
      >
        {(language.hindi && language.hindi.Close) || 'Back'}
      </Button>
    );
  };

  render() {
    //   const { otp } = this.props;
    return (
      <div className="modalContent">
        {this._renderAfterOtp()}
        {/* {otp ? this._renderAfterOtp() : this._renderBeforeOtp()} */}
      </div>
    );
  }
}

MobileLogin.contextType = LanguageContext;

export default withRouter(
  connect(
    ({ app }) => ({
      otp: app.otp,
      otpError: app.otpError,
      // isMobileVerified: app.isMobileVerified,
    }),
    dispatch => ({
      getLogin: (mobile, otpType, device) => dispatch(getOtp(mobile, otpType, device)),
      verifyOtp: (mobileOtp, mobileNumber, otpType) => {
        dispatch(verifyOtpAction(mobileOtp, mobileNumber, otpType));
      },
      verifyOtpMobileAction: (mobileOtp, mobileNumber, otpType) => {
        dispatch(verifyMobileOtp(mobileOtp, mobileNumber, otpType));
      },
      resetOtp: () => dispatch(resetOtpAction()),
    }),
  )(MobileLogin),
);
